import React from 'react';
import { Database, RefreshCw } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../../../components/ui/dialog';

const BACKUP_COLLECTIONS = [
  'Users',
  'Client Accounts',
  'Products',
  'Orders',
  'Invoices',
  'Locations',
  'Messages',
  'Client Users',
];

export const CreateBackupDialog = ({
  open,
  onOpenChange,
  backupDescription,
  setBackupDescription,
  creatingBackup,
  onCreate,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Create Database Backup</DialogTitle>
        <DialogDescription className="sr-only">Create Database Backup dialog. Use the form below to continue.</DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div>
          <Label>Description (Optional)</Label>
          <Textarea
            placeholder="Enter a description for this backup..."
            value={backupDescription}
            onChange={(e) => setBackupDescription(e.target.value)}
          />
        </div>
        <div className="text-sm text-gray-600">
          <p className="font-medium mb-2">Collections to backup:</p>
          <ul className="list-disc list-inside">
            {BACKUP_COLLECTIONS.map((name) => (
              <li key={name}>{name}</li>
            ))}
          </ul>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button
          onClick={onCreate}
          disabled={creatingBackup}
          className="bg-blue-600 hover:bg-blue-700"
          data-testid="confirm-create-backup-btn"
        >
          {creatingBackup ? (
            <>
              <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
              Creating...
            </>
          ) : (
            <>
              <Database className="h-4 w-4 mr-2" />
              Create Backup
            </>
          )}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
